import { ChevronLeft, ChevronRight } from 'lucide-react';
import { DayPicker, type DayPickerProps } from 'react-day-picker';
import { cn } from '../../lib/utils.js';
import { buttonVariants } from './Button.js';

export type CalendarProps = DayPickerProps;

export function Calendar({ className, classNames, showOutsideDays = true, ...props }: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn('p-3', className)}
      classNames={{
        months: 'flex flex-col gap-4',
        month: 'flex flex-col gap-3',
        month_caption: 'flex items-center justify-center pt-1 text-sm font-medium',
        caption_label: 'text-sm font-medium',
        nav: 'flex items-center justify-between absolute inset-x-1 top-1',
        button_previous: cn(
          buttonVariants({ variant: 'ghost', size: 'icon' }),
          'h-7 w-7 p-0 text-muted hover:text-text',
        ),
        button_next: cn(
          buttonVariants({ variant: 'ghost', size: 'icon' }),
          'h-7 w-7 p-0 text-muted hover:text-text',
        ),
        month_grid: 'w-full border-collapse',
        weekdays: 'flex',
        weekday: 'w-8 text-[0.7rem] font-normal text-muted',
        week: 'flex w-full mt-1',
        day: 'p-0 text-center text-sm relative [&:has([data-selected])]:bg-accent-soft',
        day_button: cn(
          buttonVariants({ variant: 'ghost' }),
          'h-8 w-8 p-0 font-normal aria-selected:opacity-100 border-transparent',
        ),
        selected: '[&>button]:bg-accent [&>button]:text-accent-fg [&>button]:hover:bg-accent [&>button]:hover:opacity-90',
        today: '[&>button]:border-border [&>button]:border',
        outside: 'text-muted opacity-50',
        disabled: 'text-muted opacity-30',
        hidden: 'invisible',
        ...classNames,
      }}
      components={{
        Chevron: ({ orientation, ...rest }) =>
          orientation === 'left' ? <ChevronLeft className="h-4 w-4" {...rest} /> : <ChevronRight className="h-4 w-4" {...rest} />,
      }}
      {...props}
    />
  );
}
